import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import { encryptPassword } from '../../utils/crypto';
import { decryptPassword } from '../../utils/crypto';
import padrao from '../../assets/profile.png'
import { useLocation } from 'react-router-dom';
import QRCode from 'react-qr-code';
import { Link } from 'react-router-dom';
import { QrCode } from '@mui/icons-material';

//export default function Cadastro({ setOpenModal = false, cadastroInfo = undefined }) {
export default function Cadastro() {
    const validator = require('validator');
    
    const loggedIn = sessionStorage.getItem('loggedIn');

    let editandoCadastro = sessionStorage.getItem('origemEditarPessoa');
    if (editandoCadastro && (editandoCadastro !== 'Header' && editandoCadastro !== 'Associado')) {
        editandoCadastro = '';
    }
    //console.log('Editando cadastro:', editandoCadastro);

    //era localStorage.getItem('loggedIn') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const [errorMessage, setErrorMessage] = useState('');
    const [errorPass, setErrorPass] = useState(false);
    //const [modal, setModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [image, setImage] = useState(null)
    const [imagem, setImagem] = useState({
        NomeImagem: '',
        Imagem: ''
    })
    const [uploadFotoStatus, setUploadFotoStatus] = useState('');

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
    
    const location = useLocation();

    const [campos, setCampos] = useState({
        IdPessoa: 0,
        IdGrupoUsuario: 1,
        pesNome: '',
        pesApelido: '',
        pesNascimento: '',
        pesEmail: '',
        pesSenha: '',
        confirmPassword: '',
        pesTelefone: '',
        pesCelular: '',
        pesEmergencia: '',
        pesFoto: '',
        pesProfissao: '',
        pesCEP: '',
        pesEndereco: '',
        pesBairro: '',
        pesCidade: '',
        pesEstado: '',
        pesCPF: '',
        pesCNH: '',
        pesCNHCategoria: '',
        pesCNHValidade: '',
        pesYoutube: '',
        pesFacebook: '',
        pesInstagram: '',
        pesGRPAnterior: '',
        pesToken: '',
        pesTokenData: '',
        pesObservacoes: '',
        pesAssociado: 0,
        pesStatus: 1,
        pesCriadoPOR: '',
        pesCriadoEM: customFormatDate,
        pesAlteradoPOR: '',
        pesAlteradoEM: customFormatDate,
        pesCodigoGUID: '',
        pesAdmin: 0,
        pesAlerta: 0,
        pesPIN: ''
    });

    const [cadastroInfo, setcadastroInfo] = useState({
        IdPessoa: 0,
        IdGrupoUsuario: 1,
        pesNome: '',
        pesApelido: '',
        pesNascimento: '',
        pesEmail: '',
        pesSenha: '',
        confirmPassword: '',
        pesTelefone: '',
        pesCelular: '',
        pesEmergencia: '',
        pesFoto: '',
        pesProfissao: '',
        pesCEP: '',
        pesEndereco: '',
        pesBairro: '',
        pesCidade: '',
        pesEstado: '',
        pesCPF: '',
        pesCNH: '',
        pesCNHCategoria: '',
        pesCNHValidade: '',
        pesYoutube: '',
        pesFacebook: '',
        pesInstagram: '',
        pesGRPAnterior: '',
        pesToken: '',
        pesTokenData: '',
        pesObservacoes: '',
        pesAssociado: 0,
        pesStatus: 1,
        pesCriadoPOR: '',
        pesCriadoEM: customFormatDate,
        pesAlteradoPOR: '',
        pesAlteradoEM: customFormatDate,
        pesCodigoGUID: '',
        pesAdmin: 0,
        pesAlerta: 0,
        pesPIN: ''
    });

    useEffect(() => {
        if(location.state){
            //setcadastroInfo(location.state);
            const { cadastro } = location.state;
            //console.log(cadastro);
            setcadastroInfo(cadastro);
        }
    });
    
    // console.log(campos);
    //console.log(cadastroInfo);

    
    //useEffect(() => {
        if (cadastroInfo !== undefined) {
            //console.log('CadastroInfo recebido no Cadastro.js:', cadastroInfo);
            preencherCampos();
        }
        else if (cadastroInfo === null || cadastroInfo === '{}' || cadastroInfo === undefined) {
            console.log('chegou aqui erro cadastroInfo')
            //cadastroInfo = campos;
        }
    //}, []);

    
    function preencherCampos() {
        //console.log('Preenchendo campos com as informações do cadastroInfo');
        campos.IdPessoa = cadastroInfo.IdPessoa;
        campos.IdGrupoUsuario = cadastroInfo.IdGrupoUsuario;
        campos.pesNome = cadastroInfo.pesNome;
        campos.pesApelido = cadastroInfo.pesApelido;
        campos.pesNascimento = cadastroInfo.pesNascimento;
        campos.pesEmail = cadastroInfo.pesEmail;
        campos.pesTelefone = cadastroInfo.pesTelefone;
        campos.pesCelular = cadastroInfo.pesCelular;
        campos.pesEmergencia = cadastroInfo.pesEmergencia;
        campos.pesFoto = cadastroInfo.pesFoto;
        campos.pesProfissao = cadastroInfo.pesProfissao;
        campos.pesCEP = cadastroInfo.pesCEP;
        campos.pesEndereco = cadastroInfo.pesEndereco;
        campos.pesBairro = cadastroInfo.pesBairro;
        campos.pesCidade = cadastroInfo.pesCidade;
        campos.pesEstado = cadastroInfo.pesEstado;
        campos.pesCPF = cadastroInfo.pesCPF;
        campos.pesCNH = cadastroInfo.pesCNH;
        campos.pesCNHCategoria = cadastroInfo.pesCNHCategoria;
        campos.pesCNHValidade = cadastroInfo.pesCNHValidade;
        campos.pesYoutube = cadastroInfo.pesYoutube;
        campos.pesFacebook = cadastroInfo.pesFacebook;
        campos.pesInstagram = cadastroInfo.pesInstagram;
        campos.pesGRPAnterior = cadastroInfo.pesGRPAnterior;
        campos.pesToken = cadastroInfo.pesToken;
        campos.pesTokenData = cadastroInfo.pesTokenData;
        campos.pesObservacoes = cadastroInfo.pesObservacoes;
        campos.pesAssociado = cadastroInfo.pesAssociado;
        campos.pesStatus = cadastroInfo.pesStatus;
        campos.pesCriadoPOR = cadastroInfo.pesCriadoPOR;
        campos.pesCriadoEM = cadastroInfo.pesCriadoEM;
        campos.pesAlteradoPOR = sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
        campos.pesAlteradoEM = customFormatDate;
        campos.pesCodigoGUID = cadastroInfo.pesCodigoGUID;
        campos.pesAdmin = cadastroInfo.pesAdmin;
        campos.pesAlerta = cadastroInfo.pesAlerta;
        campos.pesPIN = cadastroInfo.pesPIN;
    }
    
    // apenas alteraçao de senha
    function handleInputChange(event) {
        if(event.target.name === 'pesSenha'){
            campos['pesSenha'] = event.target.value;
            if(cadastroInfo) {
                cadastroInfo['pesSenha'] = event.target.value;
            }
        }
        else if(event.target.name === 'confirmPassword'){
            campos['confirmPassword'] = event.target.value;
            if(cadastroInfo) {
                cadastroInfo['confirmPassword'] = event.target.value;
            }
        }

        // console.log(event.target.value);

        if(event.target.name === 'pesSenha'){
            setErrorMessage('');
            setErrorPass(false);
            if(event.target.value !== campos.confirmPassword){
                setErrorMessage('As senhas não coincidem(S).');
                setErrorPass(true);
                bloqueio = true;
                
            } else if(event.target.value === campos.confirmPassword){
                setErrorMessage('');
                setErrorPass(false);
                bloqueio = false;

                campos['pesSenha'] = event.target.value;
                if(cadastroInfo) {
                    cadastroInfo['pesSenha'] = event.target.value;
                }
            }
        }
        if(event.target.name === 'confirmPassword'){
            if(event.target.value !== campos.pesSenha){
                setErrorMessage('As senhas não coincidem(CS).');
                setErrorPass(true);
                bloqueio = true;
            } else {
                bloqueio = false;
                setErrorMessage('');
                setErrorPass(false);

                campos['pesSenha'] = event.target.value;
                if(cadastroInfo) {
                    cadastroInfo['pesSenha'] = event.target.value;
                }
            }
        }
    }
    
    //#region Inputs Changes Handlers
    function handleInputChangeNome(event) {
        campos['pesNome'] = event.target.value;
        cadastroInfo['pesNome'] = event.target.value;
    }

    function handleInputChangeEmail(event) {
        campos['pesEmail'] = event.target.value;
        cadastroInfo['pesEmail'] = event.target.value;
    }

    function handleInputChangeApelido(event) {
        campos['pesApelido'] = event.target.value;
        cadastroInfo['pesApelido'] = event.target.value;
    }

    function handleInputChangeProfissao(event) {
        campos['pesProfissao'] = event.target.value;
        cadastroInfo['pesProfissao'] = event.target.value;
    }

    function handleInputChangeTelefone(event) {
        //aplicar automaticamente a máscara (99) 99999-9999 para o campo de telefone
        event.target.value = event.target.value.replace(/\D/g, '');
        if (event.target.value.length > 11) event.target.value = event.target.value.slice(0, 11);
        if (event.target.value.length > 6) {
            event.target.value = event.target.value.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3');
        } else if (event.target.value.length > 2) {
            event.target.value = event.target.value.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
        } else if (event.target.value.length > 0) {
            event.target.value = event.target.value.replace(/^(\d{0,2})/, '($1');
        }

        campos['pesTelefone'] = event.target.value;
        cadastroInfo['pesTelefone'] = event.target.value;
    }

    function handleInputChangeCelular(event) {
        //aplicar automaticamente a máscara (99) 99999-9999 para o campo de celular
        event.target.value = event.target.value.replace(/\D/g, '');
        if (event.target.value.length > 11) event.target.value = event.target.value.slice(0, 11);
        if (event.target.value.length > 6) {
            event.target.value = event.target.value.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3');
        } else if (event.target.value.length > 2) {
            event.target.value = event.target.value.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
        } else if (event.target.value.length > 0) {
            event.target.value = event.target.value.replace(/^(\d{0,2})/, '($1');
        }
        campos['pesCelular'] = event.target.value;
        cadastroInfo['pesCelular'] = event.target.value;
    }

    function handleInputChangeEmergencia(event) {
        campos['pesEmergencia'] = event.target.value;
        cadastroInfo['pesEmergencia'] = event.target.value;
    }

    function handleInputChangeNascimento(event) {
        //aplicar automaticamente a máscara dd/mm/aaaa para o campo de nascimento
        event.target.value = event.target.value.replace(/\D/g, '');
        if (event.target.value.length > 8) event.target.value = event.target.value.slice(0, 8);
        if (event.target.value.length > 4) {
            event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{0,4}).*/, '$1/$2/$3');
        } else if (event.target.value.length > 2) {
            event.target.value = event.target.value.replace(/^(\d{2})(\d{0,2})/, '$1/$2');
        }
        campos['pesNascimento'] = event.target.value;
        cadastroInfo['pesNascimento'] = event.target.value;
    }

    function handleInputChangeEndereco(event) {
        campos['pesEndereco'] = event.target.value;
        cadastroInfo['pesEndereco'] = event.target.value;
    }

    function handleInputChangeBairro(event) {
        campos['pesBairro'] = event.target.value;
        cadastroInfo['pesBairro'] = event.target.value;
    }

    function handleInputChangeCidade(event) {
        campos['pesCidade'] = event.target.value;
        cadastroInfo['pesCidade'] = event.target.value;
    }

    function handleInputChangeEstado(event) {
        campos['pesEstado'] = event.target.value;
        cadastroInfo['pesEstado'] = event.target.value;
    }

    function handleInputChangeCep(event) {
        //aplicar automaticamente a máscara 00000-000 para o campo de CEP
        event.target.value = event.target.value.replace(/\D/g, '');
        if (event.target.value.length > 8) event.target.value = event.target.value.slice(0, 8);
        if (event.target.value.length > 5) {
            event.target.value = event.target.value.replace(/^(\d{5})(\d{0,3}).*/, '$1-$2');
        }
        campos['pesCEP'] = event.target.value;
        cadastroInfo['pesCEP'] = event.target.value;
        if(campos['pesCEP'].length >= 8)
        {
            handleBlur();
        }
    }

    function handleInputChangeCpf(event) {
        //aplicar automaticamente a máscara 000.000.000-00 para o campo de CPF
        event.target.value = event.target.value.replace(/\D/g, '');
        if (event.target.value.length > 11) event.target.value = event.target.value.slice(0, 11);
        if (event.target.value.length > 9) {
            event.target.value = event.target.value.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2}).*/, '$1.$2.$3-$4');
        } else if (event.target.value.length > 6) {
            event.target.value = event.target.value.replace(/^(\d{3})(\d{3})(\d{0,3}).*/, '$1.$2.$3');
        } else if (event.target.value.length > 3) {
            event.target.value = event.target.value.replace(/^(\d{3})(\d{0,3}).*/, '$1.$2');
        }
        campos['pesCPF'] = event.target.value;
        cadastroInfo['pesCPF'] = event.target.value;
    }

    function handleInputChangeCnh(event) {
        //aplicar automaticamente a máscara 00000000000 para o campo de CNH
        event.target.value = event.target.value.replace(/\D/g, '');
        if (event.target.value.length > 11) event.target.value = event.target.value.slice(0, 11);
        campos['pesCNH'] = event.target.value;
        cadastroInfo['pesCNH'] = event.target.value;
    }

    function handleInputChangeCategoria(event) {
        campos['pesCNHCategoria'] = event.target.value;
        cadastroInfo['pesCNHCategoria'] = event.target.value;
    }

    function handleInputChangeValidade(event) {
        //aplicar automaticamente a máscara dd/mm/aaaa para o campo de validade da CNH
        event.target.value = event.target.value.replace(/\D/g, '');
        if (event.target.value.length > 8) event.target.value = event.target.value.slice(0, 8);
        if (event.target.value.length > 4) {
            event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{0,4}).*/, '$1/$2/$3');
        } else if (event.target.value.length > 2) {
            event.target.value = event.target.value.replace(/^(\d{2})(\d{0,2})/, '$1/$2');
        }
        campos['pesCNHValidade'] = event.target.value;
        cadastroInfo['pesCNHValidade'] = event.target.value;
    }

    function handleInputChangeYoutube(event) {
        campos['pesYoutube'] = event.target.value;
        cadastroInfo['pesYoutube'] = event.target.value;
    }

    function handleInputChangeFacebook(event) {
        campos['pesFacebook'] = event.target.value;
        cadastroInfo['pesFacebook'] = event.target.value;
    }

    function handleInputChangeInstagram(event) {
        campos['pesInstagram'] = event.target.value;
        cadastroInfo['pesInstagram'] = event.target.value;
    }

    function handleInputChangeGrpAnterior(event) {
        campos['pesGRPAnterior'] = event.target.value;
        cadastroInfo['pesGRPAnterior'] = event.target.value;
    }

    function handleInputChangeAdmin(event) {
        campos['pesAdmin'] = event.target.value;
        cadastroInfo['pesAdmin'] = event.target.value;
    }

    function handleInputChangeAssociado(event) {
        campos['pesAssociado'] = event.target.value;
        cadastroInfo['pesAssociado'] = event.target.value;
    }

    function handleInputChangeStatus(event) {
        campos['pesStatus'] = event.target.value;
        cadastroInfo['pesStatus'] = event.target.value;
    }

    function handleInputChangePin(event) {
        //aplicar automaticamente a máscara 0000 para o campo de PIN
        event.target.value = event.target.value.replace(/\D/g, '');
        if (event.target.value.length > 6) event.target.value = event.target.value.slice(0, 6);
        campos['pesPIN'] = event.target.value;
        cadastroInfo['pesPIN'] = event.target.value;
        handleValidaPin();
    }
    //#endregion

    function handleValidaPin(){
        if(campos.pesPIN !== '' && campos.pesPIN !== null && campos.pesPIN !== undefined && campos.pesPIN.length > 0){
            if(campos.pesPIN.length < 4){
                setErrorMessage('O PIN deve conter no mínimo 4 caracteres.');
                return;
            }
            else if(campos.pesPIN.length > 6){
                setErrorMessage('O PIN deve conter no máximo 6 caracteres.');
                return;
            }
            else if(!validator.isNumeric(campos.pesPIN)){
                setErrorMessage('O PIN deve conter apenas números.');
                return;
            } else {
                setErrorMessage('');
            
                const dadosPin = 
                { 
                    pesPIN: campos.pesPIN, 
                    IdPessoa: campos.IdPessoa 
                };
                axios
                .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=validaPinAssociado', dadosPin, {
                    headers: {
                        "X-Access-Token": "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00",
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => {
                    if(response.data.valid){
                        setErrorMessage(response.data.message);
                    } else {
                        setErrorMessage(response.data.message);
                        //setErrorMessage('PIN inválido. Por favor, verifique e tente novamente.');
                        return;
                    }
                })
                .catch(error => {
                    console.error('Erro ao validar PIN:', error);
                    setErrorMessage('Erro ao validar PIN. Por favor, tente novamente mais tarde.');
                    return;
                });
            }
        }
        else {
            setErrorMessage('');
        }
    }
    
    // pesquisa de endereço viacep
    const handleBlur = () => {
    if (campos.pesCEP.length >= 8) {
        campos.pesCEP = campos.pesCEP.replace('-', '').replace(' ','');

      fetch("https://viacep.com.br/ws/"+campos.pesCEP+"/json/")
        .then(res => res.json())
        .then(data => {
            campos['pesEndereco'] = data.logradouro;
            campos['pesCidade'] = data.localidade;
            campos['pesEstado'] = data.uf;
            campos['pesBairro'] = data.bairro;
            campos['pesCEP'] = data.cep;
            
            cadastroInfo['pesEndereco'] = data.logradouro;
            cadastroInfo['pesCidade'] = data.localidade;
            cadastroInfo['pesEstado'] = data.uf;
            cadastroInfo['pesBairro'] = data.bairro;
            cadastroInfo['pesCEP'] = data.cep;

            setCampos({pesEndereco: data.logradouro, 
                pesCidade: data.localidade, 
                pesEstado: data.uf, 
                pesBairro: data.bairro,
                pesCEP: data.cep,
                ...campos});
        });
    }
    };
    
    //console.log(cadastroInfo);
    var bloqueio = false;
    //console.log(sessionStorage.pesAdmin);

    const handleFileChange = (event) => {
        setImage(event.target.files[0]);
    };

    function handleFormSubmit(event) {
        event.preventDefault();
        var tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const elementoSenha = document.getElementById('pesSenha');
        const elementoConfirmPassword = document.getElementById('confirmPassword');
        //validar senhas
        if (elementoSenha.value !== '' && elementoConfirmPassword.value !== '') {
            setErrorMessage('');
            setErrorPass(false);
            if(elementoSenha.value !== elementoConfirmPassword.value){
                setErrorMessage('As senhas não coincidem(FS).');
                setErrorPass(true);
                bloqueio = true;
                
                // console.log(elementoSenha.value);
                // console.log(elementoConfirmPassword.value);
                
                elementoSenha.value = '';
                elementoConfirmPassword.value = '';
                elementoSenha.focus();
                return;
            } else if(elementoSenha.value === elementoConfirmPassword.value){
                setErrorMessage('');
                setErrorPass(false);
                bloqueio = false;
            }
        }

        handleValidaPin();

        // Aqui você pode adicionar a lógica para enviar os dados do formulário para o servidor
        if (bloqueio === false) {
            bloqueio = true;
            
            if (image) {
                const formData = new FormData();
                formData.append('imageFile', image)
                var reader = new FileReader();
                reader.readAsDataURL(image)
                reader.onload = function (fileLoadedEvent) {
                var srcData = fileLoadedEvent.target.result
                imagem['Imagem'] = srcData.split(',')[1]
                imagem['NomeImagem'] = uuid + '_' + image.name
                setImagem(imagem)
                }
                //console.log(imagem);
                //return;
                axios
                .post(process.env.REACT_APP_API_URL + 
                    '/routes.php?metodo=uploadFotoPessoa', formData
                , { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "multipart/form-data; charset=UTF-8"
                } })
                .then(response => {
                    campos.pesFoto = response.data['filePath'];
                    cadastroInfo.pesFoto = response.data['filePath'];
                    setUploadFotoStatus(`Sucesso: ${response.data.message}`);
                    //console.log(response);
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    setUploadFotoStatus(`Erro ao enviar: ${error.response ? error.response.data.message : error.message}`);
                    return;
                });
            }
            //console.log(campos);
            //return;
            campos["pesEmail"] = campos["pesEmail"]
                .replace(/[áàãâä]/g, 'a')
                .replace(/[éèêë]/g, 'e')
                .replace(/[íìîï]/g, 'i')
                .replace(/[óòõôö]/g, 'o')
                .replace(/[úùûü]/g, 'u')
                .replace(/[ç]/g, 'c');

            campos["pesNome"] = campos["pesNome"].toUpperCase();
            campos["pesApelido"] = campos["pesApelido"].toUpperCase();
            campos["pesProfissao"] = campos["pesProfissao"].toUpperCase();
            campos["pesEndereco"] = campos["pesEndereco"].toUpperCase();
            campos["pesCidade"] = campos["pesCidade"].toUpperCase();
            campos["pesBairro"] = campos["pesBairro"].toUpperCase();
            campos["pesEstado"] = campos["pesEstado"].toUpperCase();
            campos["pesEmail"] = campos["pesEmail"].toLowerCase();
            campos["pesCriadoPOR"] = campos["pesNome"];
            campos["pesAlteradoPOR"] = campos["pesNome"];
            
            if(sessionStorage.nomeUsuario !== undefined){
                campos["pesAlteradoPOR"] = sessionStorage.nomeUsuario;
                campos["pesCriadoPOR"] = sessionStorage.nomeUsuario;
            }

            if(elementoSenha.value !==  ''){
                campos.pesSenha = encryptPassword(elementoSenha.value);
            }

            // console.log(decryptPassword(campos.pesSenha));
            //console.log(campos);
            //return;
            //var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
            if (campos.IdPessoa > 0) {
                //console.log('Atualizando cadastro existente com ID:', campos.IdPessoa);
                //console.log(campos);
                // return;
                axios
                .post(process.env.REACT_APP_API_URL +
                '/routes.php?metodo=atualizarCadastroAssociado', campos
                , { 
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=UTF-8"
                    } 
                }
                )
                .then(response => {
                    //console.log(response.data);
                    bloqueio = false;
                    alert('Cadastro atualizado com sucesso! ' + editandoCadastro);
                    
                    //enviar email para o email de cadastro, buscando o modelo de email com a descrição Atualização de Cadastro.
                    if (1 === 1)
                    {
                        axios
                        .post(process.env.REACT_APP_API_URL +
                        `/routes.php?metodo=obtemModeloEmailPorDescricao`,
                            { emlDescricao: 'UpdateCadastro' },
                            {
                            headers: {
                                "X-Access-Token": tokenAPI,
                                "Content-Type": "application/json; charset=UTF-8"
                                }
                            }
                        )
                        .then(response => {
                            if (response.data && response.data.IdModeloEmail) {
                                const modeloEmail = response.data;
                                let mess = modeloEmail.emlCorpo;
                                mess = mess.replace('[nome]', campos.pesNome);
                                mess = '<div style="text-align: center; padding: 20px;"><img src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="Logo MGBE" style="width: 100px; margin-top: 20px;" /></ br> ' + mess;
                                
                                if(parseInt(sessionStorage.pesAdmin) === 1) {
                                    mess += "</br><span style='color: red; font-weight: bold; font-size: 12px; margin-top: 30px;'><p>Atualização de cadastro realizada pelo administrador</p><p>Você pode solicitar uma troca de senha na área do Associado</p></span>";
                                } else {
                                    mess += "</br><span style='color: blue; font-weight: bold; font-size: 12px; margin-top: 30px;'><p>Atualização de cadastro realizada pelo associado</p></span>";
                                }

                                mess += "</div>";
                                
                                const dadosEmail = {
                                    nome: campos.pesNome,
                                    email: campos.pesEmail,
                                    assunto: modeloEmail.emlAssunto,
                                    mensagem: mess
                                };

                                

                                axios
                                .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', dadosEmail, {
                                    headers: {
                                        "X-Access-Token": tokenAPI,
                                        "Content-Type": "application/json; charset=UTF-8"
                                }})
                                .then(response => {
                                    console.log('Email de atualização de cadastro enviado com sucesso:', response.data);
                                })
                                .catch(error => {
                                    console.error('Erro ao enviar email de atualização de cadastro:', error);
                                });
                            }
                        })
                        .catch(error => {
                            console.error('Erro ao buscar modelo de email de atualização de cadastro:', error);
                        });
                    }
                    
                    if(editandoCadastro === 'Header' || editandoCadastro === ''){
                        window.history.back();
                        //window.location.href = '/';
                    } else {
                        window.location.href = '/#/Associados'; // Redireciona para a página de associados
                    }
                })
                .catch(error => {
                    console.log('Houve um erro ao enviar o formulário:', error);
                    bloqueio = false;
                    alert('Houve um erro ao atualizar o cadastro. Por favor, tente novamente.' + error.message);
                });
            }
            else {
                //console.log('Criando novo cadastro');
                //return;
                axios.post(process.env.REACT_APP_API_URL +
                `/routes.php?metodo=novoCadastroAssociado`, campos
                , { headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } }
                )
                .then(response => {
                    //console.log(response.data);
                    bloqueio = false;
                    alert('Cadastro realizado com sucesso!');

                    //enviar email para o email de cadastro, buscando o modelo de email com a descrição Cadastro.
                    axios
                    .post(process.env.REACT_APP_API_URL +
                    `/routes.php?metodo=obtemModeloEmailPorDescricao`,
                        { emlDescricao: 'Cadastro' },
                        {
                        headers: {
                            "X-Access-Token": tokenAPI,
                            "Content-Type": "application/json; charset=UTF-8"
                            }
                        }
                    )
                    .then(response => {
                        if (response.data && response.data.IdModeloEmail) {
                            const modeloEmail = response.data;
                            let mess = modeloEmail.emlCorpo;
                            mess = mess.replace('[nome]', campos.pesNome);
                            mess = '<img src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="Logo MGBE" style="width: 100px; margin-top: 20px;" /></ br> ' + mess;
                            const dadosEmail = {
                                nome: campos.pesNome,
                                email: campos.pesEmail,
                                assunto: modeloEmail.emlAssunto,
                                mensagem: mess
                            };
                            axios
                            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', dadosEmail, {
                                headers: {
                                    "X-Access-Token": tokenAPI,
                                    "Content-Type": "application/json; charset=UTF-8"
                            }})
                            .then(response => {
                                console.log('Email de boas-vindas enviado com sucesso:', response.data);
                            })
                            .catch(error => {
                                console.error('Erro ao enviar email de boas-vindas:', error);
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Erro ao enviar email de boas-vindas:', error);
                    });

                    if(editandoCadastro === 'Header' || editandoCadastro === ''){
                        window.history.back();
                    } else {
                        window.location.href = '/#/Associado'; // Redireciona para a página de associados
                    }
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    bloqueio = false;
                    alert('Houve um erro ao realizar o cadastro. Por favor, tente novamente.');
                });
            }
            
        }
        //console.log('Formulário enviado:', campos);
    }

    const handlePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    //console.log(cadastroInfo)
    //console.log(loggedIn);
    
    function handleFecharModal(){
        if(cadastroInfo !== undefined || cadastroInfo === false){
            //setOpenModal(false);
            window.history.back();
        }
        else {   
            //window.location.href = '/Associado'; 
            window.history.back();
        }
    }

    // console.log(parseInt(sessionStorage.pesAdmin));
    // console.log(parseInt(campos.IdPessoa));
    // console.log(loggedIn);

    const [showQRCode, setShowQRCode] = useState(false);
    const [valorQRCode, setValorQRCode] = useState('');
    const qrCodeRef = useRef(null);
    function handleQRCode() {
        if (campos.pesCodigoGUID !== undefined && campos.pesCodigoGUID !== '') {
            setValorQRCode(`https://www.brasilextremos.com.br/#/ValidarMembro/${campos.pesCodigoGUID}`);
            setShowQRCode(!showQRCode);
        }
        else {
            alert('Código GUID não disponível para gerar QR Code.');
        }
        
    }
    const handleDownloadJpg = () => {
    // Busca o elemento SVG de dentro da nossa div de referência
    const svgElement = qrCodeRef.current ? qrCodeRef.current.querySelector('svg') : null;
    
    if (!svgElement) {
      alert('QR Code não encontrado!');
      return;
    }

    // 1. Converter o SVG para string/texto XML
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const blobURL = URL.createObjectURL(svgBlob);

    // 2. Criar um objeto de imagem na memória para carregar o SVG
    const imagem = new Image();
    
    imagem.onload = () => {
      // 3. Criar um elemento Canvas
      const canvas = document.createElement('canvas');
      
      // Definir largura e altura baseadas no SVG (ou usar 256 como padrão)
      const tamanho = svgElement.clientWidth || 256;
      canvas.width = tamanho;
      canvas.height = tamanho;
      
      const contexto = canvas.getContext('2d');

      // IMPORTANTE para JPG: Preencher o fundo com cor branca,
      // pois arquivos JPG não possuem canal alfa (transparência).
      contexto.fillStyle = '#FFFFFF';
      contexto.fillRect(0, 0, canvas.width, canvas.height);

      // 4. Desenhar o QR Code (SVG) por cima do fundo branco do canvas
      contexto.drawImage(imagem, 0, 0, tamanho, tamanho);

      // 5. Transformar o canvas em um link de imagem JPEG
      const jpgUrl = canvas.toDataURL('image/jpeg', 1.0);

      // 6. Criar um link invisível para forçar o download automático
      const linkDownload = document.createElement('a');
      linkDownload.href = jpgUrl;
      linkDownload.download = `qrcode-mgbe${campos.IdPessoa < 10 ? `000${campos.IdPessoa}` : campos.IdPessoa < 100 ? `00${campos.IdPessoa}` : campos.IdPessoa < 1000 ? `0${campos.IdPessoa}` : campos.IdPessoa}.jpg`;
      
      document.body.appendChild(linkDownload);
      linkDownload.click();
      document.body.removeChild(linkDownload);
      
      // Limpar a memória do objeto URL criado
      URL.revokeObjectURL(blobURL);
    };

    imagem.src = blobURL;
  };

    useEffect(() => {
        setTimeout(() => {
            const elemento = document.getElementById('fecharModal');
            elemento.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
    }, []);

    //aplicar automaticamente a mascara (99) 99999-9999 para o campo de telefone e celular
    // useEffect(() => {
    //     const telefoneInput = document.getElementById('pesTelefone');
    //     const celularInput = document.getElementById('pesCelular');

    //     const aplicarMascara = (input) => {
    //         input.addEventListener('input', (event) => {
    //             let valor = event.target.value.replace(/\D/g, '');
    //             if (valor.length > 11) valor = valor.slice(0, 11);
    //             if (valor.length > 6) {
    //                 valor = valor.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3');
    //             } else if (valor.length > 2) {
    //                 valor = valor.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
    //             } else if (valor.length > 0) {
    //                 valor = valor.replace(/^(\d{0,2})/, '($1');
    //             }
    //             event.target.value = valor;
    //         });
    //     };

    //     if (telefoneInput) aplicarMascara(telefoneInput);
    //     if (celularInput) aplicarMascara(celularInput);
    // }, []);
    
    return (
        <div>
            <main>
                <div style={parseInt(campos.IdPessoa) > 10000 ? {marginTop: "-120px"} : {display: "block"} }>
                    {/* fechar */}
                    <div className='d-flex w100 mt1 flex-column text-align-left'>
                        <div className='text-align-leeft w80 fs16'>
                            <button id="fecharModal" 
                                className="buttonModalPadraoLaranja fs14"
                                onClick={handleFecharModal}
                                style={{ cursor: 'pointer' }}
                            >
                                Voltar
                            </button>
                        </div>
                    </div>
                    {/* form */}
                    <form onSubmit={handleFormSubmit}>
                        <div className='headerMain'>
                            <label className='labelTitulo' >CADASTRO DE ASSOCIADO</label>
                        </div>
                        {/* foto pessoa */}
                        <div className="d-flex w100 tdAlignCenter flex-column mb2">
                            {image ? (
                                <img
                                src={URL.createObjectURL(image)}
                                alt="Logo2"
                                className="imgProfile"
                                width="150"
                                height="150"
                                />
                            ) : (
                                <img
                                src={campos.pesFoto !== null && campos.pesFoto !== '' ? process.env.REACT_APP_API_URL + "/" + campos.pesFoto : padrao} 
                                alt="" 
                                resizemode="contain"
                                className="imgProfile" />
                            )}
                            {/* File upload da foto */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <input
                                type="file"
                                name="fotoPessoa"
                                className="p1 bgGray fs12"
                                id="fotoPessoa"
                                accept=".gif,.jpg,.jpeg,.png"
                                onChange={handleFileChange}
                                // onChange={function (event) {
                                //setImage(event.target.files[0])
                                //}}
                            /> ) : null}
                            
                            <p>{uploadFotoStatus}</p>
                        </div>

                        {/* campos do form */}
                        <div className='d-flex w100 flex-column tdAlignLeft pb4'>
                            <div className='text-align-left divForm fs12'>
                                <label>
                                    <QrCode onClick={handleQRCode} style={{width: '40px', marginBottom: '-6px', marginRight: '24px', color: '#f27f05'}} />
                                    MGBE-{campos.IdPessoa < 10 ? `000${campos.IdPessoa}` : campos.IdPessoa < 100 ? `00${campos.IdPessoa}` : campos.IdPessoa < 1000 ? `0${campos.IdPessoa}` : campos.IdPessoa} {campos.pesCriadoEM}
                                </label>
                            </div>

                            {parseInt(sessionStorage.pesAdmin) === 1 && showQRCode && (
                            <>
                                <div style={{ textAlign: 'center', marginTop: '20px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <div ref={qrCodeRef}>
                                        <QRCode value={valorQRCode} />
                                    </div>
                                    <div style={{ marginLeft: '20px' }}>
                                        <div style={{ textAlign: 'center', marginTop: '10px', paddingTop: '10px', color: '#000', cursor: 'pointer' }} className='fs12'>
                                            <Link to={valorQRCode} target='_blank' style={{ color: '#000', textDecoration: 'none'  }}>
                                                <label style={{ backgroundColor: '#4CAF50', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }}>Testar o QR Code</label>
                                            </Link>
                                        </div>
                                        <div style={{ textAlign: 'center', marginTop: '10px', padding: '10px' }}>
                                            <button  className='fs12' style={{ backgroundColor: '#4CAF50', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }} 
                                                onClick={handleDownloadJpg}>
                                                Salvar como JPG
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                            <div>
                                
                            </div>
                            {/* nome */}
                            <div className='text-align-left divForm fs16'>
                                <label>Nome</label>
                            </div>
                            <div className='text-align-left divForm fs14'>
                                <input 
                                type="text" 
                                placeholder="Nome Completo" 
                                className='w100 p1 fs12'
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeNome} 
                                name='pesNome'
                                id='pesNome'
                                defaultValue={campos.pesNome}
                                required
                                />
                            </div>
                            {/* email */}
                            <div className='text-align-left divForm fs16'>
                                <label>Email</label>
                            </div>
                            <div className='text-align-left divForm fs14'>
                                <input 
                                type="email" 
                                placeholder="Email" 
                                className='w100 p1 fs12'
                                style={{ textTransform: 'lowercase'}}
                                onChange={handleInputChangeEmail}
                                name='pesEmail'
                                id='pesEmail'
                                defaultValue={campos.pesEmail}
                                required />
                            </div>
                            {/* apelido */}
                            <div className='text-align-left divForm fs16'>
                                <label>Apelido/Tarjeta</label>
                            </div>
                            <div className='text-align-left divForm fs14'>
                                <input 
                                type="text" 
                                placeholder="Apelido" 
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeApelido} 
                                name='pesApelido'
                                id='pesApelido'
                                defaultValue={campos.pesApelido}
                                required/>
                            </div>
                            {/* profissão */}
                            <div className='text-align-left divForm fs16'>
                                <label>Profissão</label>
                            </div>
                            <div className='text-align-left divForm fs14'>
                                <input 
                                type="text" 
                                placeholder="Profissao" 
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeProfissao} 
                                name='pesProfissao'
                                id='pesProfissao'
                                defaultValue={campos.pesProfissao}
                                required/>
                            </div>
                            {/* telefone */}
                            <div className='text-align-left divForm fs16'>
                                <label>Telefone</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Telefone" 
                                className='w100 p1 fs12' 
                                maxLength="15" 
                                mask="(99) 99999-9999"
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeTelefone} 
                                name='pesTelefone'
                                id='pesTelefonee'
                                defaultValue={campos.pesTelefone}
                                />
                            </div>
                            {/* celular */}
                            <div className='text-align-left divForm fs16'>
                                <label>Celular</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Celular" 
                                className='w100 p1 fs12' 
                                maxLength="15" 
                                mask="(99) 99999-9999"
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeCelular} 
                                name='pesCelular'
                                id='pesCelular'
                                defaultValue={campos.pesCelular}
                                required/>
                            </div>
                            {/* contato de emergência */}
                            <div className='text-align-left divForm fs16'>
                                <label>Contato de emergência</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Contato de emergência" 
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeEmergencia} 
                                name='pesEmergencia'
                                id='pesEmergencia'
                                defaultValue={campos.pesEmergencia}
                                required/>
                            </div>
                            {/* nascimento */}
                            <div className='text-align-left divForm fs16'>
                                <label>Data de Nascimento</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                // type="date" 
                                // format="dd/MM/yyyy"
                                placeholder="Data de Nascimento" 
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeNascimento} 
                                name='pesNascimento'
                                id='pesNascimento'
                                defaultValue={campos.pesNascimento}
                                required/>
                            </div>
                            {/* cep */}
                            <div className='text-align-left divForm fs16'>
                                <label>CEP</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="CEP" 
                                maxLength="9"
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeCep} 
                                onBlur={handleBlur}
                                name='pesCEP'
                                id='pesCEP'
                                defaultValue={campos.pesCEP}
                                required/>
                            </div>
                            {/* endereço */}
                            <div className='text-align-left divForm fs16'>
                                <label>Endereço</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Endereço" 
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeEndereco} 
                                name='pesEndereco'
                                id='pesEndereco'
                                defaultValue={campos.pesEndereco}
                                required/>
                            </div>
                            {/* bairro */}
                            <div className='text-align-left divForm fs16'>
                                <label>Bairro</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Bairro" 
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeBairro} 
                                name='pesBairro'
                                id='pesBairro'
                                defaultValue={campos.pesBairro}
                                required/>
                            </div>
                            {/* cidade */}
                            <div className='text-align-left divForm fs16'>
                                <label>Cidade</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Cidade" 
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeCidade} 
                                name='pesCidade'
                                id='pesCidade'
                                defaultValue={campos.pesCidade}
                                required/>
                            </div>
                            {/* estado */}
                            <div className='text-align-left divForm fs16'>
                                <label>Estado</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Estado" 
                                className='w100 p1 fs12' 
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeEstado} 
                                name='pesEstado'
                                id='pesEstado'
                                defaultValue={campos.pesEstado}
                                required/>
                            </div>
                            {/* cpf */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <>
                                <div className='text-align-left divForm fs16'>
                                    <label>CPF</label>
                                </div>
                                <div className='text-align-left divForm fs12'>
                                    <input 
                                    type="text" 
                                    placeholder="CPF" 
                                    className='w100 p1 fs12' 
                                    style={{ textTransform: 'uppercase' }}
                                    onChange={handleInputChangeCpf} 
                                    name='pesCPF'
                                    id='pesCPF'
                                    defaultValue={campos.pesCPF}
                                    />
                                </div> 
                            </> ) : ('')}
                            {/* CNH */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <>
                                <div className='text-align-left divForm fs16'>
                                    <label>CNH</label>
                                </div>
                                <div className='text-align-left divForm fs12'>
                                    <input 
                                    type="text" 
                                    placeholder="CNH" 
                                    className='w100 p1 fs12' 
                                    style={{ textTransform: 'uppercase' }}
                                    onChange={handleInputChangeCnh} 
                                    name='pesCNH'
                                    id='pesCNH'
                                    defaultValue={campos.pesCNH}
                                    />
                                </div>
                            </> ) : ('')}
                            {/* Categoria CNH */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <>
                                <div className='text-align-left divForm fs16'>
                                <label>Categoria CNH</label>
                                </div>
                                <div className='text-align-left divForm fs12'>
                                    <input 
                                    type="text" 
                                    placeholder="Categoria(s) da CNH" 
                                    className='w100 p1 fs12' 
                                    style={{ textTransform: 'uppercase' }}
                                    onChange={handleInputChangeCategoria} 
                                    name='pesCNHCategoria'
                                    id='pesCNHCategoria'
                                    defaultValue={campos.pesCNHCategoria}
                                    required/>
                                </div>
                            </> ) : ('')}
                            {/* Validade CNH */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <>
                                <div className='text-align-left divForm fs16'>
                                <label>Data de Validade CNH</label>
                                </div>
                                <div className='text-align-left divForm fs12'>
                                    <input 
                                    // type="date" 
                                    // format="dd/MM/yyyy"
                                    placeholder="Data de Validade CNH" 
                                    className='w100 p1 fs12' 
                                    style={{ textTransform: 'uppercase' }}
                                    onChange={handleInputChangeValidade} 
                                    name='pesCNHValidade'
                                    id='pesCNHValidade'
                                    defaultValue={campos.pesCNHValidade}
                                    required/>
                                </div>
                            </> ) : ('')}
                            {/* Youtube */}
                            <div className='text-align-left divForm fs16'>
                                <label>Youtube</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Nome do canal Youtube" 
                                className='w100 p1 fs12' 
                                //style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeYoutube} 
                                name='pesYoutube'
                                id='pesYoutube'
                                defaultValue={campos.pesYoutube}
                                />
                            </div>
                            {/* Facebook */}
                            <div className='text-align-left divForm fs16'>
                                <label>Facebook</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Perfil no Facebook" 
                                className='w100 p1 fs12' 
                                //style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeFacebook} 
                                name='pesFacebook'
                                id='pesFacebook'
                                defaultValue={campos.pesFacebook}
                                />
                            </div>
                            {/* Instagram */}
                            <div className='text-align-left divForm fs16'>
                                <label>Instagram</label>
                            </div>
                            <div className='text-align-left divForm fs12'>
                                <input 
                                type="text" 
                                placeholder="Perfil no Instagram" 
                                className='w100 p1 fs12' 
                                //style={{ textTransform: 'uppercase' }}
                                onChange={handleInputChangeInstagram} 
                                name='pesInstagram'
                                id='pesInstagram'
                                defaultValue={campos.pesInstagram}
                                />
                            </div>
                            {/* Grupo Anterior */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <>
                                <div className='text-align-left divForm fs16'>
                                <label>Moto Clube/Grupo Anterior</label>
                                </div>
                                <div className='text-align-left divForm fs12'>
                                    <input 
                                    type="text" 
                                    placeholder="Já pertenceu a algum moto clube/grupo? Qual?" 
                                    className='w100 p1 fs12' 
                                    style={{ textTransform: 'uppercase' }}
                                    onChange={handleInputChangeGrpAnterior} 
                                    name='pesGRPAnterior'
                                    id='pesGRPAnterior'
                                    defaultValue={campos.pesGRPAnterior}
                                    />
                                </div>
                            </> ) : ('')}
                            {/* Senha de acesso */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <>
                                <div className='text-align-left divForm fs16'>
                                <label>Senha de acesso</label>
                                </div>
                                <div className='text-align-left divForm fs12'>
                                    <input 
                                    type={showPassword ? 'text' : 'password'} 
                                    className='w100 p1 fs12' 
                                    onChange={handleInputChange} 
                                    name='pesSenha'
                                    id='pesSenha'
                                    autoComplete='new-password'
                                    defaultValue={campos.pesSenha}
                                    />
                                    <FontAwesomeIcon icon={!showPassword ? faEye : faEyeSlash} 
                                    style={{ width: "40px", fontSize: "30px",
                                        marginLeft: "-50px", 
                                        color: "#8d8d8d", 
                                        position: "relative", 
                                        cursor: "pointer" }} 
                                    onClick={handlePasswordVisibility}/>
                                </div>
                            </> ) : ('')}
                            {/* Confirmar senha */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <>
                                <div className='text-align-left divForm fs16'>
                                <label>Confirmar senha</label>
                                </div>
                                <div className='text-align-left divForm fs12'>
                                    <input 
                                    type={showPassword ? 'text' : 'password'} 
                                    className='w100 p1 fs12' 
                                    onChange={handleInputChange} 
                                    name='confirmPassword'
                                    id='confirmPassword'
                                    autoComplete='new-password'
                                    defaultValue={campos.confirmPassword}
                                    />
                                    <FontAwesomeIcon icon={!showPassword ? faEye : faEyeSlash} 
                                    style={{ width: "40px", fontSize: "30px",
                                        marginLeft: "-50px", 
                                        color: "#8d8d8d", 
                                        position: "relative", 
                                        cursor: "pointer" }} 
                                    onClick={handlePasswordVisibility}/>
                                </div>
                            </> ) : ('')}
                            {/* Pin de acesso */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <>
                                <div className='text-align-left divForm fs16'>
                                <label>Pin de Acesso - </label>
                                <span style={{fontSize: 13}}> Para acesso você pode criar um PIN de 4 dígitos e usá-lo para login rápido.</span>
                                </div>
                                <div className='text-align-left divForm fs12'>
                                    <input 
                                    type='text' 
                                    className='w100 p1 fs12' 
                                    onChange={handleInputChangePin} 
                                    name='pesPIN'
                                    id='pesPIN'
                                    defaultValue={campos.pesPIN}
                                    />
                                </div>
                            </> ) : ('')}
                            {/* Alertas de senha */}
                            {errorPass === true ? (
                                <div className='text-align-left divForm fs10'>
                                    <span className="AlertPassword">
                                        {errorMessage}
                                    </span>
                                </div>
                            ) : (
                            <div></div>
                            )}

                            <div className='divForm d-flex flex-row justify-content-center align-Content-center align-items-center'>
                            <>
                                {/* Cadastro Associado */}
                                {parseInt(sessionStorage.pesAdmin) === 1 && 1 === 0 ? (
                                <div style={{ width: '33%'}}>
                                    <div className='text-align-left divForm fs16'>
                                        <label>Associado?</label>
                                        <select
                                            defaultValue={campos.pesAssociado}
                                            onChange={handleInputChangeAssociado}
                                            className="pt1 pb1 fs12 w100 text-align-center" 
                                            required
                                            disabled
                                            name="pesAssociado"
                                            id="pesAssociado"
                                            >
                                                <option value="0">Não</option>
                                                <option value="1">Sim</option>
                                            </select>
                                    </div> 
                                </div> ) : ('')}
                            </>

                            <>
                                {/* Status Geral do Cadastro */}
                                {parseInt(sessionStorage.pesAdmin) === 1 && 1 === 0 ? (
                                <div style={{ width: '33%'}}>
                                    <div className='text-align-left divForm fs16'>
                                        <label>Ativo?</label>
                                        <select
                                            defaultValue={campos.pesStatus}
                                            onChange={handleInputChangeStatus}
                                            className="pt1 pb1 fs12 w100 text-align-center" 
                                            required
                                            disabled
                                            name="pesStatus"
                                            id="pesStatus"
                                            >
                                                <option value="0">Não</option>
                                                <option value="1">Sim</option>
                                            </select>
                                    </div> 
                                </div> ) : ('')}
                            </>

                            <>
                                {/* Acesso Administrativo */}
                                {parseInt(sessionStorage.pesAdmin) === 1 && 1 === 0 ? (
                                <div style={{ width: '33%'}}>
                                    <div className='text-align-left divForm fs16'>
                                        <label>Gestão?</label>
                                        <select
                                            defaultValue={campos.pesAdmin}
                                            onChange={handleInputChangeAdmin}
                                            className="pt1 pb1 fs12 w100 text-align-center" 
                                            required
                                            disabled
                                            name="pesAdmin"
                                            id="pesAdmin"
                                            >
                                                <option value="0">Não</option>
                                                <option value="1">Sim</option>
                                            </select>
                                    </div> 
                                </div> ) : ('')}
                            </>
                            </div>
                            <div>
                                {errorMessage !== '' && errorMessage !== false ? errorMessage : ''}
                            </div>

                            {/* Botão Salvar */}
                            {parseInt(sessionStorage.pesAdmin) === 1 
                            || loggedIn === null 
                            || loggedIn === false
                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                            || parseInt(campos.IdPessoa) === 0 ? (
                            <div className='text-align-left mt2 mb4 divForm fs14'>
                                <button 
                                className='buttonModalPadrao pt1 pb1 w100 fs14'
                                type="submit">
                                    SALVAR CADASTRO
                                </button>
                            </div> ) : ('')}
                            <div></div>
                            {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <div className='text-align-left mt2 mb4 divForm fs14'>
                                <label>
                                    {/* <QrCode onClick={handleQRCode} style={{width: '22px', marginBottom: '-6px', marginRight: '24px', color: '#f27f05'}} /> */}
                                    MGBE-{campos.IdPessoa < 10 ? `000${campos.IdPessoa}` : campos.IdPessoa < 100 ? `00${campos.IdPessoa}` : campos.IdPessoa < 1000 ? `0${campos.IdPessoa}` : campos.IdPessoa} {campos.pesCriadoEM}
                                </label>
                            </div>
                            ) : ('')}

                        </div>
                    </form>
                    {/* <div style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '5px', textAlign: 'center', paddingBottom: '80px' }}>
                        
                    </div> */}
                </div>
            </main>
        </div>
    );
}
